// src/components/Projects.js
import React, { useEffect, useRef } from "react";
import "../components/Projects.css";

const projectList = [
  {
    title: "Company Portfolio Website",
    tech: "React, Styled-Components",
    demo: "https://ak-template-website.netlify.app/",
    code: "https://ak-template-website.netlify.app/",
  },
  {
    title: "Blog App",
    tech: "React, Firebase Auth",
    demo: "https://akblogweb.netlify.app/",
    code: "https://github.com/ankushk385/blog-website-firebase",
  },
  {
    title: "Voice controlled news",
    tech: "React, ",
    demo: "https://aknews.netlify.app/",
    code: "https://github.com/ankushk385/voice-generated-news-app",
  },
];

export default function Projects() {
  const projectsRef = useRef(null);
  const effectRef = useRef(null);

  useEffect(() => {
    const threeScript = document.createElement("script");
    threeScript.src =
      "https://cdn.jsdelivr.net/npm/three@0.124.0/build/three.min.js";
    threeScript.async = true;

    threeScript.onload = () => {
      const vantaScript = document.createElement("script");
      vantaScript.src =
        "https://cdn.jsdelivr.net/npm/vanta@latest/dist/vanta.halo.min.js";
      vantaScript.async = true;

      vantaScript.onload = () => {
        if (!effectRef.current && window.VANTA && window.VANTA.HALO) {
          effectRef.current = window.VANTA.HALO({
            el: projectsRef.current,
            THREE: window.THREE,
            baseColor: 0xeb58f9,
            backgroundColor: 0x000000,
            amplitudeFactor: 2.8,
            xOffset: 0.2,
            size: 1.3,
          });
        }
      };

      document.body.appendChild(vantaScript);
    };

    document.body.appendChild(threeScript);

    return () => {
      if (effectRef.current) effectRef.current.destroy();
    };
  }, []);

  return (
    <section id="projects" className="projects" ref={projectsRef}>
      <div className="projects-header" data-aos="fade-up">
        <h2>Projects</h2>
        <p>Some of the work I've done recently</p>
      </div>

      <div className="projects-grid">
        {projectList.map((proj, index) => (
          <div
            className="project-card"
            key={index}
            data-aos="fade-up"
            data-aos-delay={index * 100}
          >
            <h3>{proj.title}</h3>
            <p>{proj.tech}</p>
            <div className="project-links">
              <a href={proj.demo} target="_blank" rel="noreferrer">
                Live Demo
              </a>
              <a href={proj.code} target="_blank" rel="noreferrer">
                Source Code
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
